import React from 'react';

export default function Block1Hero() {
  return (
    <section className="py-20 md:py-32 px-4 md:px-16 relative overflow-hidden bg-paper">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center w-full relative z-10">
        <div className="text-[12px] font-semibold tracking-widest uppercase text-brand mb-8">
          Operación poblacional para APS
        </div>
        <h1 className="text-[40px] sm:text-[48px] md:text-[64px] lg:text-[72px] font-bold text-ink leading-[1.1] tracking-tight mb-8 w-full max-w-4xl">
          De datos que describen la población a acciones que cambian su trayectoria.
        </h1>
        <p className="text-[18px] md:text-[22px] text-ink-soft leading-[1.6] mb-12 max-w-3xl">
          YMC-BAC identifica brechas de prevención y continuidad, determina qué debe ocurrir ahora y coordina cada acción hasta contar con evidencia de cumplimiento.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4 w-full sm:w-auto mb-12">
          <a href="/#contacto" className="bg-brand text-white px-8 py-4 text-[14px] font-semibold rounded-xl hover:bg-brand/90 transition-colors text-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand whitespace-nowrap">
            CONVERSEMOS
          </a>
          <a href="#bac-en-accion" className="bg-transparent text-ink border border-line px-8 py-4 text-[14px] font-semibold rounded-xl hover:bg-slate-50 transition-colors text-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand whitespace-nowrap">
            Conocer cómo funciona
          </a>
        </div>
        <p className="text-[14px] md:text-[16px] font-medium text-ink-soft flex items-center justify-center gap-2 w-full">
          <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 text-brand"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          <span>BAC hace el trabajo operacional. APS mantiene la decisión clínica.</span>
        </p>
      </div>
    </section>
  );
}
